<template>
  <div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase">
                <strong>Restaurar Contraseña</strong>
              </h4>
              <a-form
                class="login-form"
                :form="form"
                @submit.prevent="onSubmit"
              >
                <a-form-item label="Email">
                  <a-input
                    placeholder="Email"
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            type: 'email',
                            message: 'El correo ingresado es inválido.'
                          },
                          {
                            required: true,
                            message: 'Este campo es requerido.'
                          }
                        ]
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0,0,0,.25);"
                    />
                  </a-input>
                </a-form-item>
                <!--
                <div>
                  <router-link
                    class="text-primary utils__link--blue utils__link--underlined"
                    to="/user/login"
                    >Forgot password?</router-link
                  >
                </div>
                -->
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button width-160"
                    >Restaurar Contraseña</a-button
                  >
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: this.$form.createForm(this),
      formSubmitted: false,
      loading: false
    };
  },
  methods: {
    onSubmit(e) {
      this.form.validateFields((err, values) => {
        this.loading = true;
        if (err) {
          //console.log(err);
          this.$nprogress.done();
          this.$notification["warning"]({
            message: "hay errores de validacion",
            description: ""
          });
        } else {
          this.$nprogress.start();
          this.$auth
            .restorePassword(values.email)
            .then(data => {
              this.loading = false;
              this.$nprogress.done();
              this.$notification["success"]({
                message: "Proceso de restauración de contraseña.",
                description:
                  "Te enviamos un correo con el link para restaurar la contraseña."
              });
            })
            .catch(err => {
              //console.log(err);
              this.loading = false;
              this.$nprogress.done();
              this.$notification["warning"]({
                message: err.code,
                description: err.message
              });
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
